/**
 * STOQ "Notify me when available" shortcuts for the colour swatches
 * (related-products block on the product page).
 *
 * - Clicking the sold-out colour you're already on opens STOQ's popup.
 * - Clicking another sold-out colour goes to that product with ?notify=1,
 *   and the popup opens once the page (and STOQ's tab) has loaded.
 *
 * The popup is opened by clicking STOQ's own floating tab, so STOQ picks the
 * selected variant itself (same approach as openNotifyMe in variant-picker.js).
 */
if (!window.carpeNotifyMe) {
  window.carpeNotifyMe = (() => {
    const TAB_SELECTOR = '.restock-rocket-button-product';
    const PARAM = 'notify';

    /**
     * Clicks STOQ's tab, waiting up to `timeout` ms for STOQ to render it.
     * @param {number} timeout - How long to wait for the tab, in ms.
     */
    function openStoqPopup(timeout = 6000) {
      const tab = document.querySelector(TAB_SELECTOR);
      if (tab) {
        tab.click();
        return;
      }

      const observer = new MutationObserver(() => {
        const found = document.querySelector(TAB_SELECTOR);
        if (!found) return;
        observer.disconnect();
        setTimeout(() => found.click()); // let STOQ finish wiring the button
      });
      observer.observe(document.body, { childList: true, subtree: true });
      setTimeout(() => observer.disconnect(), timeout);
    }

    document.addEventListener('click', (evt) => {
      const swatch = evt.target.closest('.related-swatch--unavailable');
      if (!swatch) return;
      // Leave new-tab / new-window clicks alone.
      if (evt.button !== 0 || evt.metaKey || evt.ctrlKey || evt.shiftKey || evt.altKey) return;

      evt.preventDefault();
      if (swatch.classList.contains('related-swatch--active')) {
        openStoqPopup();
        return;
      }

      const url = new URL(swatch.href, window.location.origin);
      url.searchParams.set(PARAM, '1');
      window.location.href = url.toString();
    });

    // Arrived from a sold-out swatch: tidy the URL, then open the popup.
    const params = new URLSearchParams(window.location.search);
    if (params.has(PARAM)) {
      params.delete(PARAM);
      const query = params.toString();
      window.history.replaceState(window.history.state, '', `${window.location.pathname}${query ? `?${query}` : ''}${window.location.hash}`);
      openStoqPopup();
    }

    return { open: openStoqPopup };
  })();
}
